import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router'

// evertel
import { Button, Card, CardBody, Col, Row } from '@evertel/web/ui'
import { useService } from '@evertel/di'
import { SessionService } from '@evertel/session/SessionService'
import { Analytics } from '@evertel/analytics'


const CrisisNoAccess = () => {

    const sessionService = useService(SessionService, [])
    const analytics = useService(Analytics)

    const navigate = useNavigate()

    useEffect(() => {
        localStorage.removeItem('crisis')
        analytics.logView('/register/crisisnoaccess')
    }, [])


    return (
        <div className="app d-flex flex-row justify-content-center align-items-center fadeIn animated auth-layout" style={{ height: '100vh' }}>
            <Row className="justify-content-center" style={{ minWidth: '54vh', maxWidth: '100vh' }}>
                <Col md="12">
                    <Card className="mx-4">
                        <CardBody className="p-4">
                            <div className="pb-4">
                                <h1 className="pb-1 weight-900" style={{ fontSize: '3rem' }}>
                                    Restricted Access to Crisis Rooms
                                </h1>
                                <p className="h4 pb-3">
                                    Because you did not register with a government email address and we cannot verify you as a government employee,
                                    you cannot join any crisis rooms at this time.
                                </p>
                                <p className="h4 pb-3">
                                    To access crisis rooms, you can change your email to a government email address or join your agency with your agency's Access Code.
                                </p>
                                <div className="text-center mt-4">
                                    <Link
                                        to={`/account/profile/${sessionService.currentUserId}`}
                                        className="me-3 btn btn-info btn-lg">
                                        Change My Email
                                    </Link>
                                    <Link
                                        to={'/account/departments'}
                                        className="btn btn-info btn-lg me-3">
                                        Join My Agency
                                    </Link>
                                    <Link
                                        to={'/landing'}
                                        className="btn btn-primary btn-lg">
                                        Continue to Evertel...
                                    </Link>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export { CrisisNoAccess }
